import { useEffect } from "react";

const useRokt = (triggerRokt) => {
  useEffect(() => {
    let emailForRokt = sessionStorage.getItem("roktEmail");
    sessionStorage.removeItem("roktEmail");

    if (triggerRokt) {
      const roktScript = document.createElement("script");

      roktScript.innerHTML = `(function(r, o, k, t, n, e, w, a, _) {
            r._ROKT_ = n;
            r[n] = r[n] || {
              id: t,
              h: w,
              lc: [],
              it: new Date(),
              onLoaded: function(c) {
                r[n].lc.push(c);
              },
            };
            a = o.createElement("script");
            a.type = "text/javascript";
            a.async = !0;
            a.src = k;
            if (e) {
              a.integrity = e;
              a.crossOrigin = "anonymous";
            }
            _ = o.getElementsByTagName("script")[0];
            _.parentNode.insertBefore(a, _);
          })(
            window,
            document,
            "https://apps.rokt.com/wsdk/integrations/snippet.js",
            "2861881290961237713_5e90413dea2f418197eb2b2e5ec8a2d1",
            "rokt"
          );
    
          rokt.onLoaded(function(rokt) {
            rokt.setAttributes({
              // Recommended
              email: "${emailForRokt}",
              emailmd5: "",
              emailsha256: "",
            });
          });`;
      document.head.appendChild(roktScript);
    }
  }, [triggerRokt]);
  return null;
};

export default useRokt;
